import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	selectDepositAll({ commit }, params) { //初始查询margin/getRefundMargin
		return new Promise((resolve, reject) => {
			axios.post(`deposit/selectDepositAll`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  selectRefundMargin({ commit }, params) { //退款初始查询
		return new Promise((resolve, reject) => {
			axios.post(`margin/selectRefundMargin`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  insertDeposit({ commit }, params) {  //保存
		return new Promise((resolve, reject) => {
			axios.post('deposit/insertDeposit', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  selectMoney({ commit }, params) {  //提交查询其他订单
		return new Promise((resolve, reject) => {
			axios.post('margin/selectMoney', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  refundInsertMargin({ commit }, params) {  //退款保存
		return new Promise((resolve, reject) => {
			axios.post('margin/refundInsertMargin', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getDeposit({ commit }, params) {  //查找
		return new Promise((resolve, reject) => {
			axios.get('deposit/selectDeposit', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  updateDeposit({ commit }, params) { //修改
		return new Promise((resolve, reject) => {
			axios.post('deposit/insertDeposit', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  approveRefundStart({ commit }, params) { //驳回
		return new Promise((resolve, reject) => {
			axios.post('margin/approveRefundStart', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
  findCurrentUserOrgInfo({ commit }, params) {  //获取当前登陆人信息
		return new Promise((resolve, reject) => {
			axios.get('user/findCurrentUserOrgInfo', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateDepositStatus({ commit }, params) {  // 删除当前行
		return new Promise((resolve, reject) => {
			axios.get('deposit/updateDepositStatus', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  updateRefundMarginStatus({ commit }, params) {  // 退款删除当前行
		return new Promise((resolve, reject) => {
			axios.get('margin/updateRefundMarginStatus', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

}
